
const TrashIcon = ({
  width = 20,
  height = 20,
  color = "#767676",
  strokeWidth = 1.67,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.444 6.11111L14.7694 15.5553C14.7113 16.3693 14.0339 17 13.2178 17H6.78131C5.9652 17 5.28785 16.3693 5.2297 15.5553L4.55512 6.11111M8.44401 9.22222V13.8889M11.5551 9.22222V13.8889M12.3329 6.11111V3.77778C12.3329 3.34822 11.9847 3 11.5551 3H8.44401C8.01446 3 7.66623 3.34822 7.66623 3.77778V6.11111M3.77734 6.11111H16.2218"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TrashIcon;
